import React, {useState} from 'react';
import {TableLineLoader} from "../../front/loader/TableLineLoader";
import DateService from "../../../service/DateService";
import {NavLink} from "react-router-dom";
import {ApiService} from "../../../service/ApiService";
import {DeleteConfirme} from "../DeleteConfirme";
import {collection} from "../../../models/collection";
import {scrollTo} from "../../../service/ToolsService";

type CollectionListProp = {
  collections: collection[],
  loading?: boolean,
  refresh: () => void,
}

export const CollectionList = ({collections, loading, refresh}: CollectionListProp) => {
  const [del, setDel] = useState(undefined as undefined | collection);

  const deleteCollection = async (collection: collection) => {
    await ApiService.delete(`/collection/${collection.collectionId}`);
    refresh();
  };

  return (
    <>
      <table className="table table-responsive table-hover border">
        <thead>
        <tr className="table-primary">
          <th>Nom</th>
          <th className="text-center w150px d-lg-table-cell d-none">Modification</th>
          <th className="w190px"></th>
        </tr>
        </thead>
        <tbody>
        {loading && (
          <tr>
            <td colSpan={3} className="pt-4 pb-4 ps-5 pe-5">
              <TableLineLoader/>
            </td>
          </tr>
        )}

        {!loading && collections.map((collection: collection, i: number) => (
          <tr key={i} className="align-middle">
            <td>{collection.label}</td>
            <td className="text-center d-lg-table-cell d-none">
              {DateService
                .toLocaleString(collection.updatedAt ?? collection.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
              }
            </td>
            <td className="text-end">
              <NavLink to={`/admin/equipment/collection/edit/${collection.collectionId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                <i className="fa-solid fa-pencil me-1"/> modifier
              </NavLink>
              <button className="btn btn-xs btn-danger" onClick={() => setDel(collection)}><i className="fa-solid fa-xmark me-1"/>supprimer</button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
      {del && (
        <DeleteConfirme confirme={(c: boolean) => {
          if (c) {
            deleteCollection(del);
          }

          setDel(undefined);
        }}/>
      )}
    </>
  );
}
